import React from 'react'

import './Logo.css'

const Logo = () => (
  <img className="fmbm-logo" src={require('./img/Logo.png')} alt="Logo" />
)

export default Logo



// WEBPACK FOOTER //
// ./src/Components/Logo/Logo.js